(function () {
    'use strict';

    /*@ngInject*/
    const ForgotPasswordRepository = function (baseRepository) {

        angular.extend(this, baseRepository);

        this.forgotPassword = function (username, emailAddress) {
            var url = '/rest/User/forgotPassword',
                payload = 'username=' + username + '&emailAddress=' + emailAddress,
                config = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                };

            return this.post(url, payload, config);
        };
    };

    angular.module('gw-um-auth')
        .service('forgotPasswordRepository', ForgotPasswordRepository);
})();
